<template>
  <el-config-provider :locale="locale">
    <div class="ys_main">
      <div class="ys_box">
        <div class="ys_title">免责条款</div>
        <div class="ys_content">
          <p>感谢您信任并使用上海悦宝互联网金融信息服务股份有限公司网站服务及模拟交易软件。为便于您全面正确地理解网站服务及模拟交易软件的风险，特此提示您在使用网站服务及模拟交易软件前阅读以下条款内容：</p>
          <p>我公司不提供实际证券交易环境，包括网站、APP及软件方式。我公司提供的模拟交易软件仅为虚拟资金及仿真交易环境。我公司在此郑重提示用户注意下列风险：</p>
          <p class="ys_h2">（1）切勿将模拟交易及仿真环境理解为真实的证券交易环境，在模拟交易中提供的资金为虚拟资金，在仿真环境的所有委托、撤单、成交、持仓数据均为虚拟数据。</p>
          <p class="ys_h2">（2）我公司不提供任何投资咨询服务、不提供任何投资顾问服务、不提供任何投资理财服务。</p>
          <p class="ys_h2">（3）我公司不提供任何金融产品销售服务，包括但不限于私募基金、公募基金、信托产品。</p>
          <p class="ys_h2">（4）因战争、自然灾害、地震、火灾、台风及其他各种不可抗力因素引起的停电、网络系统故障、电脑故障等原因可能造成用户的证券金融数据信息查阅中断、模拟交易数据损失。</p>
          <p class="ys_h2">（5）用户使用的计算机可能由于存在性能缺陷、质量问题、计算机病毒、软件及硬件故障等原因，而对用户的数据浏览查阅、模拟交易产生影响。</p>
          <p class="ys_h2">（6）由于用户的计算机应用操作能力或互联网知识的缺乏，或对有关信息的错误理解，可能对用户的交易时间或交易数据造成影响，从而给用户造成损失。</p>
          <p class="ys_h2">（7）因黑客攻击、计算机病毒、用户自身的疏忽导致账号或密码泄露，可能会给用户造成模拟环境被恶意操作等问题，且仅限于模拟环境。</p>
          <p>我公司不承担上述风险所导致的损失或责任。用户一经使用上海悦宝互联网金融信息服务股份有限公司的网站及模拟交易软件，即视为用户已经完全了解并理解上述风险，并且能够承担上述风险或损失。我公司在此郑重承诺，我们将采取先进的技术措施，最大限度地保护网站及模拟交易环境的安全。</p>
          <p>我公司将竭尽全力确保所提供信息的准确性和可靠性，但不保证其适用性、可得性、及时性、准确性或可靠性，对于因中断、缺陷、错误、延时、不准确或遗漏而引起的任何损失或损害不承担任何责任（无论是侵权责任、合同责任还是其他形式的责任）。</p>
          <p>我公司在此郑重提醒用户，以上各条款均为免责条款，上海悦宝互联网金融信息服务股份有限公司不承担与此相关的任何损失和法律责任。</p>

        </div>
      </div>

    </div>


  </el-config-provider>
</template>
<script>

import zhCn from "element-plus/lib/locale/lang/zh-cn";


export default {
  components: {},
  data() {
    return {
      locale: zhCn,
    };
  },
  methods: {}
};

</script>

<style scoped>
.ys_main {
  background-color: #fff;
  width: 100%;
  height: 100%;
}

.ys_box {
  padding: 50px 15%;
}

.ys_title {
  text-align: center;
  font-size: 16px;
  color: #040404;
  line-height: 24px;
  margin-bottom: 20px;
}

.ys_content {
  color: #040404;
  font-size: 14px;
  line-height: 24px;
  white-space: pre-wrap;
}

.ys_content p {
  margin: 8px 0 0 0;
}

.ys_h2 {
  margin: 18px 0 6px 0;
  font-weight: 600;
}

.ys_h3 {
  margin: 12px 0 4px 0;
  font-weight: 500;
}

.us_test {
  display: block;
  font-weight: 400;
  font-size: 16px;
  color: #040404;
  line-height: 24px;
  margin-bottom: 15px;
}


</style>
